import React, { useEffect, useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconButton, Menu } from '@mui/material';
import { FactureOpenSearch, useSociete } from '@europrocurement/l2d-domain';
import {
    MenuAccessToDossier,
    MenuAccessToPrescriber,
    MenuDownloadInvoice,
    MenuGenerateCreditNote,
    MenuGeneratePaymentLink,
    dossiersBasePath,
} from '@europrocurement/l2d-modules';
import MenuAccessToDossierCollection from '@europrocurement/l2d-modules/modules/Factures/components/list/menuActionItems/MenuAccessToDossierCollection';
import { PRESCRIBER_LIST } from '../../../../Prescripteurs/constants/paths';
import { ordersBasePath } from '../../../../Orders/constants';

export type ActionMenuListeFactureProps = {
    facture: FactureOpenSearch;
};

const ActionMenuListInvoicesBack: React.FunctionComponent<ActionMenuListeFactureProps> = function ({
    facture,
}) {
    const [dossierCollectionId, setDossierCollectionId] = useState<number | undefined>();
    const [dossierId, setDossierId] = useState<number | undefined>();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const xIdSociete = useSociete();

    useEffect(() => {
        // extract first dossierId or display an other subMenu ?
        if (facture.dossiers && facture.dossiers.length > 0) {
            setDossierId(facture.dossiers[0].dossierId);

            if (facture.dossiers[0].collectionId) {
                setDossierCollectionId(facture.dossiers[0].collectionId);
            }
        }
    }, [facture.dossiers]);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
        >
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <FaOptionIcon
                    icon={['fasl', 'ellipsis-vertical']}
                    sx={{ fontSize: '1rem' }}
                />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuDownloadInvoice facture={facture} />

                {dossierId && (
                    <MenuAccessToDossier
                        dossierId={dossierId}
                        dossiersBasePath={dossiersBasePath}
                    />
                )}

                {facture.prescripteurId && (
                    <MenuAccessToPrescriber
                        prescriberPath={PRESCRIBER_LIST}
                        prescripteurId={facture.prescripteurId}
                    />
                )}

                {facture.factureEnPreparation === 0 ? (
                    <>
                        {facture.id &&
                        facture.totalTtc &&
                        facture.totalTtc > 0 &&
                        !facture.idFactureAvoir ? (
                            <MenuGenerateCreditNote
                                facture={facture}
                                xIdSociete={xIdSociete}
                            />
                        ) : null}

                        {facture.id &&
                        facture.totalTtc &&
                        facture.totalTtc > 0 &&
                        !facture.idFactureAvoir &&
                        !facture.paye ? (
                            <MenuGeneratePaymentLink id={facture.id} />
                        ) : null}
                    </>
                ) : null}

                {dossierCollectionId && (
                    <MenuAccessToDossierCollection
                        dossierCollectionId={dossierCollectionId}
                        dossierCollectionBasePath={ordersBasePath}
                    />
                )}
            </Menu>
        </div>
    );
};

export default ActionMenuListInvoicesBack;
